import { normaliseViewLanguage, sameViewLanguage } from './viewLanguages.js';

export const SUMMARY_VOICE_VERSION = 7;

export function summaryAudioRequest(endpoint, shareId, audioSrc, options = {}) {
  const base = String(endpoint || '').replace(/\/+$/, '');
  if (!base) return null;
  const target = normaliseViewLanguage(options.language);
  if (target && !sameViewLanguage(target, options.sourceLanguage)) {
    const streamBase = String(options.streamEndpoint || base).replace(/\/+$/, '');
    return shareId ? { url: `${streamBase}/exhibition-audio/${encodeURIComponent(shareId)}/0?part=summary&language=${encodeURIComponent(target)}`, method: 'GET', stream: true } : null;
  }
  // Saved audio is a site-owned immutable asset, never a new synthesis request.
  if (typeof audioSrc === 'string' && audioSrc.startsWith(`${base}/view-audio-assets/`)
    && /^[a-f0-9]{64}\.mp3$/.test(audioSrc.slice(`${base}/view-audio-assets/`.length))) {
    return { url: audioSrc, method: 'GET' };
  }
  return shareId ? { url: `${base}/view-audio/${encodeURIComponent(shareId)}`, method: 'POST' } : null;
}
